<template>
  <div class="zhFukuan">
  	<meta name="description" content="以诺教育成立于2014年，源起于其母公司诺亚财富（中国财富管理行业的开创者和领军者，2010年率先美国纽交所上市，股票代码NOAH）十多年的学习型组织沉淀，围绕“财富与人生”这个大主题，打造各类拓展视野、跨界创新、凝聚人脉、守护家庭、滋养身心的高端课程，全方位打造高尚、富有、快乐的人生，实现有形财富和无形财富的和谐统一。"/>
		<title>订单支付-以诺教育</title>
  	<headTop></headTop>
    <div id="PaymentOrder">
      <div class="imagess"></div>

      <div class="Order" v-for="item in list">
        <div class="zhorderNumber">
          <div class="numCon">
            <p class="number">订单已生成！订单号：{{item.order_id}}</p>
            <p class="zhcontents">
              课程名称：{{item.name}}
              <br/>
              下单时间：{{item.order_date}}
            </p>
          </div>
          <div class="paymenta">
            <p class="pay">待支付</p>
            <p class=payNowt>￥{{item.unit_price}}</p>
          </div>
        </div>

        <div class="close" id="closeT"></div>
      </div>
      <div class="erweima">
			    <div class="QRtext">请使用微信“扫一扫”，扫描二维码支付</div>
				  <div v-html="a" class="qqq">{{a}}</div>
	  </div>
    </div>
  </div>
</template>

<script>
	import headTop from "./headTop/headTop"
	export default{
		name:"paymentQR",
		components:{headTop},
		data(){
			return{
				a:'',
				list:[],
				id:this.$route.params.id,
				time:''
			}
		},
		mounted(){
			var that=this
			that.$ajax({
				method:'post',
				url:'/api/QrCodeGet',
				params:{order_id:that.id}
			}).then(function(data){
				that.a=data.data
			}).catch(function(err){
				console.log(err)
		})
			that.$ajax({
			  	  method:"post",
			  	  url:"/api/MyOrderDetail",
			  	  params:{id:that.id}
			 }).then(function(data){
			  	that.list=data.data.result
			  	that.time=data.data.result[0].pending_paytime
			  		 function timer(intDiff){
    window.setInterval(function(){
    var day=0,
        hour=0,
        minute=0,
        second=0;//时间默认值
    if(intDiff > 0){
        day = Math.floor(intDiff / (60 * 60 * 24));
        hour = Math.floor(intDiff / (60 * 60)) - (day * 24);
        minute = Math.floor(intDiff / 60) - (day * 24 * 60) - (hour * 60);
        second = Math.floor(intDiff) - (day * 24 * 60 * 60) - (hour * 60 * 60) - (minute * 60);
    }
    if (minute <= 9) minute = '0' + minute;
    if (second <= 9) second = '0' + second;
    if(day > 0){
    	$('.close').html("请在"+'<s id="h"></s>'+day+'天'+'<s></s>'+'<s id="h"></s>'+hour+':'+'<s></s>'+minute+':'+'<s></s>'+second+''+"内支付，逾时订单将自动关闭");
    }else{
    	$('.close').html("请在"+'<s id="h"></s>'+hour+':'+'<s></s>'+minute+':'+'<s></s>'+second+''+"内支付，逾时订单将自动关闭");
    }
    
    intDiff--;
    }, 1000);
}
		$(function(){
					timer(that.time)
			})
			  }).catch(function(err){
			  	console.log(err)
			  })
			  
			  /*------------------------------轮询-------------------------------------------*/
			     var timer=setInterval(function(){
			     	    that.$ajax({
			     	    	 method:"post",
						  	   url:"/api/MyOrderDetail",
						  	  params:{id:that.id}
			     	    }).then(function(data){
			     	    	if(data.data.result[0].order_status==2){
			     	    		clearInterval(timer)
			     	    		that.$router.push({name:'PaySuccess'})
			     	    	}
			     	    }).catch(function(err){
			     	    	console.log(err)
			     	    })
			     },3000)
		}
	}
</script>

<style >
  #PaymentOrder{width:100%;background:#f4f5f9;padding:1px 0 0 0;box-sizing:border-box;}
  .imagess{width:960px;height:65px;box-sizing:border-box;margin:30px auto;background:url(../assets/jindutiao.png) no-repeat 140px -160px;}
  .Order{width:960px;height:191px;background:#ffffff;margin:0 auto;}
  .zhorderNumber{width:960px;;height:138px;padding:23px 30px;box-sizing:border-box;border-bottom:1px solid #e6e6e6;}
  .numCon{width:600px;float:left;}
  .number{font-size:20px;color:#4f4f4f;padding-top:15px;}
  .zhcontents{font-size:14px;color:#909090;padding-top:15px;}
  .paymenta{width:180px;float:right;height:100%;border-left:1px solid #e6e6e6;padding-left:20px;box-sizing:border-box;}
  .pay{font-size:14px;color:#4f4f4f;}
  .payNowt{font-size:32px;color:#4f4f4f;padding:15px 0;}
  .close{padding:18px 30px;color:#ff5050;}
  .erweima{width:960px;height:350px;margin:10px auto 0;background:#fff;}
	.qqq{clear: both;text-align: center;}
	.QRtext{text-align: center;font-size: 18px;padding:60px 0 0 0;}
</style>



// WEBPACK FOOTER //
// paymentQR.vue?4eadce86